export const TOKEN_NAME = "dpjTkn";
export const TOKEN_KEY = "dpjTknKy";